export default "__VITE_ASSET__d4f60d52__"